var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13715 12.75C4.54385 15.1413 6.99373 17.371 8.96173 18.9237C10.2937 19.9746 10.9597 20.5 12 20.5C13.0403 20.5 13.7063 19.9746 15.0383 18.9237C17.9806 16.6024 22 12.7677 22 9.14198C22 3.08505 16.4998 0.823679 12 5.50262C7.50016 0.823679 2 3.08505 2 9.14201C2 9.84102 2.1494 10.5478 2.41168 11.25H6.03647L6.75433 9.81429C7.26416 8.79463 8.76109 8.93376 9.07427 10.0299L10.1416 13.7656L11.7926 9.91333C12.2454 8.85687 13.7639 8.92003 14.1274 10.0104L14.5406 11.25H18C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75H14.3604C13.8223 12.75 13.3447 12.4057 13.1745 11.8953L12.9123 11.1086L11.2433 15.0028C10.78 16.084 9.21566 15.9849 8.89251 14.8538L7.80855 11.06L7.30902 12.059C7.09728 12.4825 6.66445 12.75 6.19098 12.75H3.13715Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.f0bd917cb2ed45e7e2c8708e4bf9c725.svg";
export { ForwardRef as ReactComponent };